export function orgColor(name: string): string {
  let hash = 5381;
  for (let i = 0; i < name.length; i++) hash = (hash * 33) ^ name.charCodeAt(i);
  const hue = (hash >>> 0) % 360;
  return `hsl(${hue}, 65%, 42%)`;
}

export function tenantAccentColor(t: { name: string; brandColor?: string | null }): string {
  return t.brandColor ?? orgColor(t.name);
}

/**
 * Turn a normalized token (snake/kebab-case index like "first_aid_beauty" or
 * "body-hydration") into a human-readable label ("First Aid Beauty", "Body
 * Hydration") for display. Used by the Orgs table's default brand/industry
 * columns, which store the normalized value but should render prettily.
 */
export function humanizeLabel(value: string): string {
  return value
    .replace(/[_-]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function orgInitials(name: string): string {
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return name.slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/**
 * True when the user has at least one access entry on a SUPER_TENANT.
 * Drives the small platform-admin marker shown next to the user across
 * People table, Person drawer, Org drawer members, and Role drawer members.
 */
export function isSuperTenantMember(
  entries: ReadonlyArray<{ access: { tenant: { type: string } } }> | undefined,
): boolean {
  return !!entries && entries.some((e) => e.access.tenant.type === "SUPER_TENANT");
}

export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUuid(value: string): boolean {
  return UUID_RE.test(value);
}
